import { render } from "./UserShowPage.vue?vue&type=template&id=60287746"
import script from "./UserShowPage.vue?vue&type=script&lang=js"
export * from "./UserShowPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__